<template>
  <div class="container py-4">
    <!-- Page Title -->
    <h2 class="fw-bold mb-4 text-center">
      <i class="bi bi-gear-fill me-2 text-primary"></i>
      Website Settings
    </h2>

    <div class="row g-4">
      <!-- HOME CARD -->
      <div class="col-md-3">
        <div class="card shadow border-0 h-100 card-home">
          <div class="card-body text-center text-white">
            <i class="bi bi-house-door-fill display-4"></i>
            <h5 class="mt-3">Home Page</h5>
            <p class="small">
              Edit homepage banner, welcome text and main content.
            </p>
            <button
              class="btn btn-light btn-sm"
              data-bs-toggle="modal"
              data-bs-target="#editHomeModal"
            >
              <i class="bi bi-pencil-square"></i> Edit Home
            </button>
          </div>
        </div>
      </div>

      <!-- ABOUT CARD -->
      <div class="col-md-3">
        <div class="card shadow border-0 h-100 card-about">
          <div class="card-body text-center text-white">
            <i class="bi bi-info-circle-fill display-4"></i>
            <h5 class="mt-3">About Page</h5>
            <p class="small">
              Update academy description, mission and history.
            </p>
            <button
              class="btn btn-light btn-sm"
              data-bs-toggle="modal"
              data-bs-target="#editAboutModal"
            >
              <i class="bi bi-pencil-square"></i> Edit About
            </button>
          </div>
        </div>
      </div>

      <!-- CONTACT CARD -->
      <div class="col-md-3">
        <div class="card shadow border-0 h-100 card-contact">
          <div class="card-body text-center text-white">
            <i class="bi bi-envelope-fill display-4"></i>
            <h5 class="mt-3">Contact Page</h5>
            <p class="small">
              Change phone number, email and address information.
            </p>
            <button
              class="btn btn-light btn-sm"
              data-bs-toggle="modal"
              data-bs-target="#editContactModal"
            >
              <i class="bi bi-pencil-square"></i> Edit Contact
            </button>
          </div>
        </div>
      </div>

      <!-- LESSONS CARD -->
      <div class="col-md-3">
        <div class="card shadow border-0 h-100 card-lessons">
          <div class="card-body text-center text-white">
            <i class="bi bi-journal-bookmark-fill display-4"></i>
            <h5 class="mt-3">Lessons</h5>
            <p class="small">
              Manage lessons, add new content, and organize courses.
            </p>
            <button
              class="btn btn-light btn-sm"
              data-bs-toggle="modal"
              data-bs-target="#editLessonsModal"
            >
              <i class="bi bi-pencil-square"></i> Edit Lessons
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- HOME MODAL -->
    <div
      class="modal fade"
      id="editHomeModal"
      tabindex="-1"
      aria-labelledby="editHomeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content bg-dark text-white border-pink">
          <div class="modal-header border-bottom-pink">
            <h5 class="modal-title" id="editHomeModalLabel">Edit Home</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <HomeContent ref="homeContent" />
        </div>
      </div>
    </div>

    <!-- ABOUT MODAL -->
    <div
      class="modal fade"
      id="editAboutModal"
      tabindex="-1"
      aria-labelledby="editAboutModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content bg-dark text-white border-pink">
          <div class="modal-header border-bottom-pink">
            <h5 class="modal-title" id="editAboutModalLabel">Edit About</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <AboutContent ref="aboutContent" />
        </div>
      </div>
    </div>

    <!-- CONTACT MODAL -->
    <div
      class="modal fade"
      id="editContactModal"
      tabindex="-1"
      aria-labelledby="editContactModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content bg-dark text-white border-pink">
          <div class="modal-header border-bottom-pink">
            <h5 class="modal-title" id="editContactModalLabel">Edit Contact</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <ContactContent ref="contactContent" />
        </div>
      </div>
    </div>

    <!-- LESSONS MODAL -->
    <div
      class="modal fade"
      id="editLessonsModal"
      tabindex="-1"
      aria-labelledby="editLessonsModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content bg-dark text-white border-pink">
          <div class="modal-header border-bottom-pink">
            <h5 class="modal-title" id="editLessonsModalLabel">Edit Lessons</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <LessonsContent ref="lessonsContent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AboutContent from "@/components/ContentPage/AboutContent.vue";
import ContactContent from "@/components/ContentPage/ContactContent.vue";
import HomeContent from "@/components/ContentPage/HomeContent.vue";
import LessonsContent from "@/components/ContentPage/LessonsContent.vue";

export default {
  name: "SettingsPage",
  components: {
    HomeContent,
    AboutContent,
    ContactContent,
    LessonsContent,
  },
  mounted() {
    // Home Modal
    const homeModal = document.getElementById("editHomeModal");
    homeModal.addEventListener("shown.bs.modal", () => {
      this.$refs.homeContent.getContent();
    });

    // About Modal
    const aboutModal = document.getElementById("editAboutModal");
    aboutModal.addEventListener("shown.bs.modal", () => {
      this.$refs.aboutContent.loadContent();
    });

    // Contact Modal
    const contactModal = document.getElementById("editContactModal");
    contactModal.addEventListener("shown.bs.modal", () => {
      this.$refs.contactContent.loadContent();
    });

    // Lessons Modal
    const lessonsModal = document.getElementById("editLessonsModal");
    lessonsModal.addEventListener("shown.bs.modal", () => {
      this.$refs.lessonsContent.loadContent();
    });
  },
};
</script>

<style scoped>
.card {
  border-radius: 15px;
  transition: all 0.3s;
  cursor: pointer;
}

.card:hover {
  transform: translateY(-6px) scale(1.02);
}

/* CARD COLORS */
.card-home {
  background: linear-gradient(135deg, #007bff, #4facfe);
}
.card-about {
  background: linear-gradient(135deg, #6f42c1, #9d6bff);
}
.card-contact {
  background: linear-gradient(135deg, #28a745, #5dd39e);
}
.card-lessons {
  background: linear-gradient(135deg, #fd7e14, #ffb84d);
}

.card-body i {
  margin-bottom: 10px;
}
</style>
